import React from 'react';
import { isMobile } from 'src/shared/helpers';

import { Button } from '@alfalab/core-components/button/cssm';
import { Gap } from '@alfalab/core-components/gap/cssm';
import { Typography } from '@alfalab/core-components/typography';

export const Otp2Form = () => (
    <form className='authForm textAlignCenter' method='POST' action='/my.policy'>
        <Typography.Title view='small' tag='h1' font='system'>
            Кажется, вас долго не было
        </Typography.Title>
        <Gap size={12} />
        <Typography.Text view={isMobile ? 'primary-small' : 'primary-medium'}>
            Войдите снова
        </Typography.Text>
        <Gap size={32} />
        <input type='hidden' name='otp2' value='true' />
        <Button view='primary' type='submit' block={true}>
            {isMobile ? 'Продолжить' : 'Войти'}
        </Button>
    </form>
);
